import { setSafariBottom } from './modules/sp-menu'
import './modules/top'
import './modules/back_to_top_btn'
import './modules/tab'
import './modules/about'
import './modules/museum-guide'
import './modules/news'
import './modules/publications'
import './modules/exhibition-event'
import './modules/collection'
import './modules/silk-road'

window.addEventListener('load', function () {
  // 二重初期化防止用フラグ
  let inited = false

  const initAfterLoaded = () => {
    if (inited) return
    inited = true

    // ===== ここから下が「.is-loaded 付与後」に実行される処理 =====

    // SP: ナビ開閉
    if (window.matchMedia('(max-width: 1140px)').matches) {
      const navTrigger = document.querySelector('.js_nav_trigger')
      const closeTrigger = document.querySelector('.js_close_trigger')
      const nav = document.querySelector('.js_nav_target_sp')
      const thisBody = document.body

      const closeNav = () => {
        thisBody.classList.remove('scroll_stop')
        navTrigger?.classList.remove('is-current')
        nav?.classList.remove('is-current')
      }

      if (navTrigger && nav) {
        navTrigger.addEventListener('click', () => {
          setSafariBottom()

          requestAnimationFrame(() => {
            navTrigger.classList.toggle('is-current')
            thisBody.classList.toggle('scroll_stop')
            nav.classList.toggle('is-current')

            setTimeout(setSafariBottom, 100)
            setTimeout(setSafariBottom, 300)
          })
        })

        if (closeTrigger) {
          closeTrigger.addEventListener('click', () => {
            navTrigger.classList.toggle('is-current')
            thisBody.classList.toggle('scroll_stop')
            nav.classList.toggle('is-current')
          })
        }

        nav.querySelectorAll('a').forEach((link) => {
          link.addEventListener('click', closeNav)
        })

        // SP: 子メニュー開閉
        nav.querySelectorAll('.has_child').forEach((item) => {
          item.addEventListener('click', function (e) {
            if (e.target.closest('.child_nav')) return

            this.classList.toggle('is-current')
          })
        })
      }
    }

    // アンカーのスムーススクロール
    const getHeaderOffset = () => {
      const header = document.querySelector('header')
      return header ? header.offsetHeight + 30 : 100
    }

    const scrollToHash = (hash, smooth = true) => {
      if (!hash) return

      const target = document.querySelector(hash)
      if (!target) return

      const offset = getHeaderOffset()
      const top = target.getBoundingClientRect().top + window.scrollY - offset

      window.scrollTo({
        top,
        behavior: smooth ? 'smooth' : 'auto',
      })
    }

    // 同一ページ内アンカー
    document.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', function (e) {
        const href = this.getAttribute('href')
        if (!href || href === '#') return

        const url = new URL(href, location.href)
        const hash = url.hash
        if (!hash) return

        const target = document.querySelector(hash)
        if (!target) return

        e.preventDefault()

        scrollToHash(hash, true)

        // URLにもhashを反映したい場合
        history.pushState(null, '', hash)
      })
    })

    // 別ページから hash 付きで遷移してきた場合
    if (location.hash) {
      // ブラウザの自動スクロール後に補正する
      setTimeout(() => {
        scrollToHash(location.hash, false)
      }, 100)
    }

    // inview: 一度だけ .is-show 付与
    ;(() => {
      const targets = document.querySelectorAll('.inview')
      if (!targets.length) return

      const io = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return

            entry.target.classList.add('is-show')
            observer.unobserve(entry.target)
          })
        },
        {
          root: null,
          rootMargin: '0px 0px -10% 0px',
          threshold: 0.1,
        },
      )

      targets.forEach((el) => io.observe(el))
    })()

    // ===== ここまで「.is-loaded 後」 =====
  }

  // ここで .is-loaded を付け、付与“後”に初期化を走らせる
  setTimeout(() => {
    document.documentElement.classList.add('is-loaded')
    initAfterLoaded()
  }, 500)
})
